import React, { useContext, useEffect, useReducer, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Store } from '../../Store';
import { getError } from '../../utils';
import LoadingBox from '../../components/LoadingBox';
import PageHeader from '../../components/shared/PageHeader';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import ConfirmModal from '../../components/ConfirmModal';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loadingFetch: true };
    case 'FETCH_SUCCESS':
      return { ...state, rifas: action.payload, loadingFetch: false };
    case 'FETCH_FAIL':
      return { ...state, loadingFetch: false, errorFetch: action.payload };
    case 'CREATE_REQUEST':
      return { ...state, loadingCreate: true };
    case 'CREATE_SUCCESS':
      return { ...state, loadingCreate: false };
    case 'CREATE_FAIL':
      return { ...state, loadingCreate: false };
    default:
      return state;
  }
};

const inputCls =
  'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring';

export default function NewTicket() {
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;

  const [numero, setNumero] = useState('');
  const [rifa, setRifa] = useState('');
  const [precio, setPrecio] = useState('');

  const [showModal, setShowModal] = useState(false);

  const [{ loadingFetch, loadingCreate, rifas }, dispatch] = useReducer(reducer, {
    rifas: [],
    loadingFetch: true,
    loadingCreate: false,
    error: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const result = await axios.get('/api/rifas', {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
      } catch (error) {
        dispatch({ type: 'FETCH_FAIL', payload: error.message });
      }
    };
    fetchData();
  }, []);

  const addTicketHandler = async () => {
    try {
      dispatch({ type: 'CREATE_REQUEST' });
      await axios.post('/api/tickets/crearTicket', { numero, rifa, precio });
      toast.success('Ticket creado');
      navigate('/AdminScreen/tickets');
    } catch (ex) {
      toast.error(getError(ex));
    }
  };

  return (
    <div className='space-y-6'>
      {(loadingCreate || loadingFetch) && <LoadingBox overlay={true} />}

      <ConfirmModal
        show={showModal}
        title='Crear Ticket'
        message='¿Seguro desea crear el ticket?'
        onConfirm={addTicketHandler}
        onCancel={() => setShowModal(false)}
        confirmLabel='Crear'
        cancelLabel='Cancelar'
      />

      <PageHeader
        title='Crear Ticket'
        actions={
          <Button variant='outline' onClick={() => navigate(-1)}>
            <ArrowLeft className='h-4 w-4' />
            Atrás
          </Button>
        }
      />

      <div className='mx-auto max-w-lg'>
        <Card>
          <CardHeader>
            <CardTitle>Datos del ticket</CardTitle>
          </CardHeader>
          <CardContent>
            <form
              onSubmit={e => {
                e.preventDefault();
                setShowModal(true);
              }}
              className='space-y-4'
            >
              <div className='space-y-1.5'>
                <label className='text-sm font-medium text-foreground'>Número</label>
                <input
                  type='text'
                  required
                  className={inputCls}
                  onChange={e => setNumero(e.target.value)}
                />
              </div>

              <div className='space-y-1.5'>
                <label className='text-sm font-medium text-foreground'>Bono</label>
                <div className='relative'>
                  <select
                    className='h-9 w-full appearance-none rounded-md border border-input bg-background pl-3 pr-8 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring'
                    onChange={e => setRifa(e.target.value)}
                  >
                    <option value=''>Seleccioná un bono…</option>
                    {rifas.map(r => (
                      <option key={r._id} value={r._id}>
                        {r.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className='space-y-1.5'>
                <label className='text-sm font-medium text-foreground'>Precio</label>
                <input
                  type='number'
                  required
                  className={inputCls}
                  onChange={e => setPrecio(e.target.value)}
                />
              </div>

              <div className='flex justify-end pt-2'>
                <Button type='submit'>Crear Ticket</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
